import { render, staticRenderFns } from "./DocumentLinksDialog.vue?vue&type=template&id=1ffdd462&scoped=true"
import script from "./DocumentLinksDialog.vue?vue&type=script&lang=js"
export * from "./DocumentLinksDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentLinksDialog.vue?vue&type=style&index=0&id=1ffdd462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdd462",
  null
  
)

export default component.exports